import './index.scss';
import { Button } from '@phi/components';
import { defineComponent, h } from 'vue';

export default defineComponent({
    props: {
        title: {
            required: true,
            type: String,
        },

        on: {
            required: true,
            type: String,
        },

        off: {
            required: true,
            type: String,
        },

        value: {
            required: true,
            type: Boolean,
        },
    },

    emits: {
        'update:value': (x: boolean) => true,
    },

    methods: {
        on_click() {
            this.$emit('update:value', !this.value);
        },
    },

    render() {
        return h(Button, { class: 'button-toggle', onClick: this.on_click }, () => [
            h('span', { class: 'title' }, this.title),
            h('span', { class: 'subtitle' }, this.value ? this.on : this.off),
        ]);
    },
});
